// Import model
import { DataviewCalendarEventResponse } from '../models/DataviewCalendarEventResponse';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { CalendarEvent } from '../models/CalendarEvent';
import { DataView } from '../models/DataView';
import { FilterCalendarEventRequest } from '../models/FilterCalendarEventRequest';

// Import dependency serializers (for complex types)
import { CalendarEventSerializer } from './CalendarEventSerializer';
import { DataViewSerializer } from './DataViewSerializer';
import { FilterCalendarEventRequestSerializer } from './FilterCalendarEventRequestSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for DataviewCalendarEventResponse - handles JSON serialization and deserialization with type validation
 */
export class DataviewCalendarEventResponseSerializer {
  /**
   * Deserializes a JSON string into a DataviewCalendarEventResponse instance
   */
  static deserialize(json: string): DataviewCalendarEventResponse {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a DataviewCalendarEventResponse instance
   */
  static fromObject(obj: any): DataviewCalendarEventResponse {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to DataviewCalendarEventResponse');
    }


    const instance: DataviewCalendarEventResponse = {
      result: obj['Result'] ? (obj['Result'] as any[]).map((item: any) =>
        CalendarEventSerializer.fromObject(item)
      ) : [] as any,
      request: obj['Request'] ? FilterCalendarEventRequestSerializer.fromObject(obj['Request']) : undefined as any,
      dataView: obj['DataView'] ? DataViewSerializer.fromObject(obj['DataView']) : undefined as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of DataviewCalendarEventResponse instances
   */
  static deserializeArray(json: string): DataviewCalendarEventResponse[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a DataviewCalendarEventResponse instance to a JSON string
   */
  static serialize(instance: DataviewCalendarEventResponse): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a DataviewCalendarEventResponse instance to a plain object
   */
  static toObject(instance: DataviewCalendarEventResponse): any {
    return {
      'Result': instance.result?.map((item: any) =>
        CalendarEventSerializer.toObject(item)
      ),
      'Request': instance.request ? FilterCalendarEventRequestSerializer.toObject(instance.request) : undefined,
      'DataView': instance.dataView ? DataViewSerializer.toObject(instance.dataView) : undefined,
    };
  }

  /**
   * Serializes an array of DataviewCalendarEventResponse instances to a JSON string
   */
  static serializeArray(instances: DataviewCalendarEventResponse[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
